import {
  GET_APP_INFO_FAILED,
  GET_APP_INFO_SUCCESS,
  GET_CURRENCIES_SUCCESS,
  GET_CURRENCIES_FAIL,
  GET_CITIES_SUCCESS,
  GET_CITIES_FAIL,
  GET_COMM_CHANNELS_SUCCESS,
  GET_COMM_CHANNELS_FAIL,
  GET_MUNICIPALITIES_SUCCESS,
  GET_MUNICIPALITIES_FAIL,
} from "./actionTypes"

const initialState = {
  appInfo: {},
  currencies: [],
  cities: [],
  commChannels: [],
  municipalities: [],
  error: {},
}

const appInfo = (state = initialState, action) => {
  switch (action.type) {
    case GET_APP_INFO_SUCCESS:
      return {
        ...state,
        appInfo: action.payload,
      }

    case GET_APP_INFO_FAILED:
      return {
        ...state,
        error: action.payload,
      }

    case GET_CURRENCIES_SUCCESS:
      return {
        ...state,
        currencies: action.payload,
        error: {},
      }

    case GET_CURRENCIES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_CITIES_SUCCESS:
      return {
        ...state,
        cities: action.payload,
        error: {},
      }

    case GET_CITIES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_COMM_CHANNELS_SUCCESS:
      return {
        ...state,
        commChannels: action.payload,
        error: {},
      }

    case GET_COMM_CHANNELS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_MUNICIPALITIES_SUCCESS:
      return {
        ...state,
        municipalities: action.payload,
        error: {},
      }

    case GET_MUNICIPALITIES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      state = { ...state }
      break
  }
  return state
}

export default appInfo
